import {Button, Card, Col, Divider, Form, message, Modal, Row, Space} from "antd";
import {ComplaintRequestDto} from "../../../dto/ComplaintRequestDto";
import customerChangeRequestService from "../../../service/customerChangeRequestService";
import ErrorHandler from "../../../util/ErrorHandler";
import {useEffect, useState} from "react";
import {MSG_COMPLAINT_HISTORY_LIST_FETCH_FAILURE_ERROR} from "../../../util/Messages";
import TextArea from "antd/es/input/TextArea";
import ChangeRequestHistoryTableComp from "./changeRequestHistoryTableComp";


interface ComplaintHistoryProps {
    cin: string
}

const ComplaintsRequestHistoryComp = (props: ComplaintHistoryProps) => {
    const [form] = Form.useForm();
    const [isLoading, setLoading] = useState(false);
    const [complaintsHistoryList, setComplaintsHistoryList] = useState<ComplaintRequestDto[]>()
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        fetchComplaintsList(props.cin)
    }, []);

    const fetchComplaintsList = (cin: string) => {
        setLoading(true)
        customerChangeRequestService.getComplaintChangeRequestHistory(cin).then((res) => {
            if (res.data.results) {
                setComplaintsHistoryList(res.data.results)
                setLoading(false)
            } else {
                message.error(MSG_COMPLAINT_HISTORY_LIST_FETCH_FAILURE_ERROR)
                setLoading(false)
            }
        }).catch(reason => {
            ErrorHandler.handleError(reason)
            setLoading(false)
        })
    }

    const handleCancel = () => {
        setIsModalOpen(false);
    };


    const onShowModal = (record: any) => {
        setIsModalOpen(true);
        form.setFieldsValue({complaint: record.complaint})
    }
    return (
        <>
            <Row gutter={[24, 12]}>

                <Col span={24}>
                    <ChangeRequestHistoryTableComp tableData={complaintsHistoryList} onShowModal={onShowModal}
                                                   loading={isLoading}/>
                </Col>
            </Row>
            <Modal title="Complaint History"
                   open={isModalOpen}
                   footer={null}
                   onCancel={handleCancel}
                   width={800}
                   centered
                   style={{top: 20, paddingBottom: 20}}>
                <Row gutter={[24, 12]} className={'form-item-mb-12'} style={{marginTop: 18}}>
                    <Col span={24}>
                        <Card title="Complaint Details" size={'small'}>
                            <Form
                                className='form-input'
                                layout={"vertical"}
                                form={form}
                            >
                                <Row gutter={[12, 0]}>
                                    <Col span={24}>
                                        <Form.Item
                                            name={"complaint"}>
                                            <TextArea rows={4} disabled/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Divider style={{marginBottom: 12}}></Divider>
                    </Col>
                    <Col span={24}>
                        <Space style={{float: 'right'}}>
                            <Button
                                    onClick={handleCancel}
                                    style={{
                                        width: 80,
                                    }}>Cancel</Button>
                        </Space>
                    </Col>
                </Row>

            </Modal>
        </>
    )
}
export default ComplaintsRequestHistoryComp;